// extracted by mini-css-extract-plugin
module.exports = {"subLabel":"Columns_subLabel__3ozbk","column":"Columns_column___Dzn_"};